/**
 * OPT-06 后台角色/账号状态中文标签与色板。
 * 角色枚举来自 @liyu/shared-types ADMIN_ROLE_CODES（后台角色唯一来源）。
 */
import type { AdminAccountStatus, AdminRoleCode } from '@liyu/shared-types';

export const ADMIN_ROLE_LABELS: Record<AdminRoleCode, string> = {
  SUPER_ADMIN: '超级管理员',
  CONTENT_EDITOR: '内容运营',
  ACTIVITY_OPERATOR: '活动运营',
  MODERATOR: '社区审核',
  CUSTOMER_SERVICE: '客服',
};

export const ADMIN_ROLE_OPTIONS = (Object.keys(ADMIN_ROLE_LABELS) as AdminRoleCode[]).map(
  (value) => ({ value, label: ADMIN_ROLE_LABELS[value] }),
);

export const ADMIN_ACCOUNT_STATUS_LABELS: Record<AdminAccountStatus, string> = {
  ACTIVE: '启用',
  DISABLED: '已禁用',
};

export const ADMIN_ACCOUNT_STATUS_COLORS: Record<AdminAccountStatus, string> = {
  ACTIVE: 'green',
  DISABLED: 'red',
};

export const ADMIN_ACCOUNT_STATUS_OPTIONS = (
  Object.keys(ADMIN_ACCOUNT_STATUS_LABELS) as AdminAccountStatus[]
).map((value) => ({ value, label: ADMIN_ACCOUNT_STATUS_LABELS[value] }));
